import React, { Fragment, useContext } from 'react';
import { object, bool, func, string } from 'prop-types';
import * as StyledOutcomesModal from 'apps/journey/components/modals/outcomes/styled-outcomes-modal';
import withColor from 'util/hoc/with-color';
import withData from 'util/hoc/with-data';
import withConfig from 'util/hoc/with-config';
import { resolve } from 'library/helpers/path-resolver';
import Outcome from 'apps/journey/components/modals/outcomes/outcome';
import searchOutcomes from 'apps/journey/queries/search-outcomes';
import Query from 'library/util/query';
import UserOutcomesContext from 'apps/journey/context/user-outcomes-context';

const AllOutcomes = ({
  graph_data,
  graph_loading,
  handle_graph_loading,
  handleClick,
  configuration,
  ...props
}) => {
  const userOutcomesContext = useContext(UserOutcomesContext);
  if (graph_loading) return handle_graph_loading();

  const mapOutcomes = (outcomes) =>
    outcomes
      .filter(
        (out) => !userOutcomesContext?.outcomes?.some((uo) => uo.id === out.id)
      )
      .map((outcome, i) => (
        <Outcome
          outcome={outcome}
          key={i}
          handleClick={handleClick}
          outcomeLink={`/${outcome.id}`}
          modal={true}
          hideDetails
        />
      ));

  const outcomes = resolve(
    graph_data,
    'search_outcomes',
    resolve(graph_data, 'outcomes', [])
  );

  return (
    <Fragment>
      <StyledOutcomesModal.OutcomesWrapper>
        {outcomes && mapOutcomes(outcomes)}
      </StyledOutcomesModal.OutcomesWrapper>
    </Fragment>
  );
};

AllOutcomes.dependantPropPath = 'searchValue';
AllOutcomes.query = async (cancelToken, { searchValue = '' }) =>
  await Query(searchOutcomes(searchValue), null, { cancelToken });

AllOutcomes.propTypes = {
  graph_data: object,
  graph_loading: bool,
  handleClick: func,
  configuration: object,
  outcomeLinkBase: string,
};

export default withConfig(withColor(withData(AllOutcomes)));
